import React from 'react';
import {Segment, Divider} from 'semantic-ui-react';
import{Certificate, coursePicker, GetDrivers} from'./';

class Egitimler extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            certificateType: 'Anti Skid',
            driverId: 0,
        };
        this.changeCPicker = this.changeCPicker.bind(this);
        this.ChangeTabs = this.ChangeTabs.bind(this);
        this.getData = this.getData.bind(this);
    }
    getData(val){
        this.setState({
            driverId: val
        });
    }
  

    changeCPicker(event,data){
        this.setState({
            certificateType: data.value 
        });
    }
    ChangeTabs(event, data){
        this.setState({
            driverId: [data.value]
        });
    }
              
    render() {
        return (  
            <div> 
                <Segment id = 'Egitimler' style={{height: '50%'}}>
                    <div className ='panel-pages-top'>
                        <h1 id='Egitimler'>Egitimler</h1>
                        <div id='EgitimlerPickers'>
                            {coursePicker.bind(this)()}
                            <GetDrivers sendData = {this.getData}/>
                        </div>
                    </div>
                    <Divider/>
                    <Certificate driverId = {this.state.driverId} certificateType = {this.state.certificateType}/>
                </Segment> 
                    
            </div>
        );
    }
}

export {Egitimler};



// WEBPACK FOOTER //
// ./src/components/PanelPages/Egitimler.jsx